import {NavAvatar} from "../../nav/NavAvatar";
import * as React from "react";
import './CommentReply.pcss';
import {Ago} from "./Ago";
import * as moment from "moment-timezone";

export const CommentReply = (props:{reply:any, }) => {

  let nameOrNickname = ''; props.reply.userId ? props.reply.userId.nameOrNickname : '';
  let isPractitioner = false;
  if(props.reply.userId) {
    nameOrNickname = props.reply.userId.nameOrNickname;
    isPractitioner = !!props.reply.userId.isDietitian || !!props.reply.userId.isVendorBoothHost;
  }

  return (
      <div className="comment-reply">
        <div className={"crep-avatar"}>
          <NavAvatar user={props.reply.userId} variant={'xsmall'} />
        </div>
        <div className={"crep-body"}>
          <h4 className={`crep-name-and-date${isPractitioner?' verified':''}`}>
            {isPractitioner && <span className="material-icons verified" aria-hidden="true">verified</span>}
            <strong>{nameOrNickname}</strong>
            <Ago when={moment(props.reply.dateCreated)} />
          </h4>
          <p className="crep-text">{props.reply.comment}</p>
        </div>
      </div>
  );

}
